//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {windVane} from '../../../utils/tmallGenius'
import Hub from './hub.vue'

export default {
  components: {Hub,},
  data() {
    return {
      isTimeout: false, //连接超时
    }
  },
  beforeRouteEnter(to, from, next) {
    windVane.setNavTitle("添加智能主机");
    next();
  },
  /*------------------------------------------- 开始运行 -------------------------------------------------------*/
  created() {

  },
  methods: {
    /*------------------------------------------- 绑定函数 -------------------------------------------------------*/
    /*  点击添加主机
    * */
    addHubClick(){
      this.toast_success('添加成功');
      if ( !this.isTimeout ){
        this.isTimeout = true;
      }else{
        this.$router.replace({
          path: '/connect/zigbee/hub_list_added'
        });
      }
    }
  },
};



// WEBPACK FOOTER //
// ./src/pages/connect/zigbee/Hub_list.vue